"use client";
// @ts-strict-ignore
import React from "react";
import {
  StyledCopyrightContainer,
  FooterRow,
  FooterText,
  DesktopOnly,
  RecaptchaWrapper,
  MobileOnly,
  MobileDivider,
  LegalLinksWrapper
} from "./style";
import RecaptchaText from "components/parts/RecaptchaText";
import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";
import LanguageSwitcher from "./LanguageSwitcher";
import { Link } from "i18n/routing";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";
import { Body } from "app/_components/components/Text/Body";

const LegalLinks = () => {
  const t = useTranslations(FILES.COMMON);
  return (
    <LegalLinksWrapper>
      <Link target="_blank" href="/legal/cryptopedia-site-policy">
        <Body size="xs" className="whitespace-nowrap text-gray-600">
          {t("sitePolicy")}
        </Body>
      </Link>
      <Link target="_blank" href="/legal/legal-notice">
        <Body size="xs" className="whitespace-nowrap text-gray-600">
          {t("legalNotice")}
        </Body>
      </Link>
    </LegalLinksWrapper>
  );
};

const Copyright = () => {
  const t = useTranslations(FILES.COMMON);
  const { isUK, isEU } = useCountryStateCookies();

  return (
    <StyledCopyrightContainer>
      <MobileOnly>
        <LanguageSwitcher center />
        <MobileDivider />
        <div
          style={{
            paddingTop: "16px",
            paddingBottom: "16px",
            width: "100%"
          }}
        >
          <LegalLinks />
        </div>
      </MobileOnly>

      <FooterRow>
        <FooterText>
          {isEU ? (
            <React.Fragment>
              <Body size="xs" className="text-gray-500">
                Gemini Intergalactic EU Ltd., a private limited liability
                company incorporated and registered in Malta, with company
                registration number C110029, is duly authorised by the Malta
                Financial Services Authority as a Crypto-Asset Service Provider
                pursuant to Regulation 2023/1114 on Markets in Crypto-Assets
                (“MiCA”) as integrated in Malta by the Markets in Crypto Assets
                Act (Chapter 647, Laws of Malta). Gemini Intergalactic EU, Ltd
                is authorised to provide the following services: (i) providing
                custody and administration of crypto-assets on behalf of clients
                (ii) exchange of crypto-assets for funds; (iii) exchange of
                crypto-assets for other crypto-assets; (iv) execution of orders
                for crypto-assets on behalf of clients; (v) placing of
                crypto-assets; (vi) reception and transmission of orders for
                crypto-assets on behalf of clients; and (vii) providing transfer
                services for crypto-assets on behalf of clients.
              </Body>
              <Body size="xs" className="text-gray-500">
                Your Fiat Account is provided by Gemini Payments Europe,
                Limited, which is regulated by the Central Bank of Ireland.
                Gemini Payments Europe, Limited is an electronic money
                institution that issues electronic money and provides related
                payment services, with firm reference number C432664.
              </Body>
              <Body size="xs" className="text-gray-500">
                Other services referenced in this website are currently not
                regulated activities under MiCA and may not necessarily be
                available to the customers residing in European Economic Area
                (EEA).
              </Body>
            </React.Fragment>
          ) : isUK ? (
            <React.Fragment>
              <Body size="xs" className="text-gray-600">
                Gemini Payments UK, Ltd and Gemini Intergalactic UK, Ltd are
                affiliates of Gemini Trust Company, LLC and wholly owned
                subsidiaries of Gemini Space Station LLC..
              </Body>
              <Body size="xs" className="text-gray-600">
                Gemini Payments UK, Ltd is authorised and regulated by the
                Financial Conduct Authority, under Firm Reference Number:
                900988. Gemini Intergalactic UK, Ltd is registered with the
                Financial Conduct Authority, under Firm Reference Number:
                921817.
              </Body>
            </React.Fragment>
          ) : (
            <Body size="xs" className="text-gray-600">
              Gemini Trust Company, LLC NMLS #1518126. Gemini Moonbase, LLC NMLS
              #2403509.
            </Body>
          )}
          <Body size="xs" className="text-gray-600">
            {t("copyright", { year: new Date().getFullYear() })}
          </Body>
        </FooterText>
      </FooterRow>

      <div
        style={{
          display: "flex",
          justifyContent: "between",
          width: "100%"
        }}
      >
        <RecaptchaWrapper>
          <RecaptchaText
            css={`
              max-width: 547px;
              align-items: center;
              padding: 0;
              margin-top: 16px;
              p {
                text-align: center;
                margin-bottom: 0;
              }
            `}
          />
        </RecaptchaWrapper>

        <DesktopOnly>
          <LegalLinks />
          <LanguageSwitcher />
        </DesktopOnly>
      </div>
    </StyledCopyrightContainer>
  );
};

export default Copyright;
